export const LOGO_ENDPOINT = 'claimfileuploaderapi/v1/logo'